export default __webpack_public_path__ + "static/media/post-2.73020f50.png";